export default __webpack_public_path__ + "static/media/hummingbird.0474d053.svg";